// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import i18n from './i18n/i18n'
import VRouter from 'vue-router'
import axios from 'axios'
import GlobalVar from './global'
import ElementUI from 'element-ui'
import { Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ECharts from 'echarts'
import App from './App'
import Login from './components/page/Login'
import Home from './components/common/Home'
import Dashboard from './components/page/Dashboard'
import AppManagement from './components/page/AppManagement'
import CreateDownload from './components/page/CreateDownload'
import DownloadList from './components/page/DownloadList'
import CreateDelete from './components/page/CreateDelete'
import DownloadDetail from './components/page/task/DownloadDetail'
import TerminalManagement from './components/page/TerminalManagement'
import SystemAdmin from './components/page/SystemAdmin'
import AppEdit from './components/page/AppEdit'
import AppManagementContain from './components/page/AppManagementContain'
import Diagnostic  from './components/page/Diagnostic'
import DiagnosticDetial from './components/page/DiagnosticDetial'
import DiagnosticList from './components/page/DiagnosticList'
import OpenAlert from './components/page/OpenAlert'
import AlertHistory from './components/page/AlertHistory'
import MerchantManage from './components/page/MerchantManage'
import Merchantlist from './components/page/Merchantlist'
import MerchantAdde from './components/page/MerchantAdde'
import GroupManage from './components/page/GroupManage'
import GroupAdd from './components/page/group/GroupAdd'
import Grouplist from './components/page/Grouplist'
import GroupEdit from './components/page/group/GroupEdit'
import GroupDetail from './components/page/GroupDetail'
import GroupTerminalParameter from './components/page/group/GroupTerminalParameter'
import AdminList from './components/page/AdminList'
import AdminAdd  from './components/page/AdminAdd'
import ModifyPassword from './components/page/ModifyPassword'
import Quit from './components/page/Quit'
import Copy from './components/page/Copy'
import TerminalList from './components/page/TerminalList'
import TerminalAdd from './components/page/TerminalAdd'
import TerminalOperate from './components/page/TerminalOperate'
import AppDownload from './components/page/app/AppDownload'
import functionList from './components/page/function/FunctionList'
import functionAdd from './components/page/function/FunctionAdd'
import functionEdit from './components/page/function/FunctionEdit'

//报表
import reportDetail from './components/page/report/ReportDetail'
import reportDownload from './components/page/report/ReportDownload'
import TerminalListReport from './components/page/report/TerminalListReport'
import TerminalParameterReport from './components/page/report/TerminalParameterReport'
import createTable from './components/page/report/CreateTable'

// 自定义工具类
import yjMessage from './utils/yjMessage.js'
import yyUtils from './utils/yyUtils.js'

Vue.config.productionTip = false;
Vue.prototype.$echarts = ECharts;
Vue.prototype.globalVar = GlobalVar;
Vue.prototype.yjMessage = yjMessage;
Vue.prototype.yyUtils = yyUtils;

Vue.use(ElementUI);
Vue.use(ECharts);
Vue.use(VRouter);

let loadingInstance=null;
let axiosIns = axios.create({
  timeout: 40 * 1000
});


const router = new VRouter({
    // mode: 'history',
    routes: [{
            path: '/',
            redirect: '/login'
        },{
            path: '/login',
            component: Login
        },{
            path: '/home',
            meta: { login: true },
            component: Home,
            redirect: '/dashboard',
            children: [{
                    path: '/dashboard',
                    meta: { login: true },
                    component: Dashboard
                },{
                    path: '/appManagementContain',
                    meta: { login: true },
                    component: AppManagementContain,
                    redirect:'/appManagement',
                    children:[{
                      path: '/appManagement',
                      component: AppManagement
                    },{
                      path: '/AppEdit',
                      meta: { login: true },
                      component: AppEdit
                    }]
                },{
                    path: '/createDownload',
                    meta: { login: true },
                    component: CreateDownload,
                },{
                    path: '/downloadList',
                    meta: { login: true },
                    component: DownloadList
                },{
                    path: '/createDelete',
                    meta: {login:true},
                    component:CreateDelete,
                },{
                    path: '/downloadDetail/:id/:type',
                    meta: { login: true },
                    component: DownloadDetail
                },{
                    path: '/terminalManagement',
                    meta: { login: true },
                    component: TerminalManagement,
                    redirect: '/terminalList',
                    children: [{
                        path: '/terminalList',
                        meta: { login: true },
                        component: TerminalList
                    },{
                        path: '/terminalOperate/:id/:sn',
                        meta: { login: true },
                        component: TerminalOperate
                    }]
                },{
                    path: '/diagnostic',
                    meta: { login: true },
                    component: Diagnostic,
                    redirect: '/diagnosticList',
                    children: [{
                      path: '/diagnosticList',
                      meta: { login: true },
                      component: DiagnosticList
                    },{
                      path: '/diagnosticDetial',
                      meta: { login: true },
                      component: DiagnosticDetial
                    }]
                },{
                    path: '/openAlert',
                    meta: { login: true },
                    component: OpenAlert
                },{
                    path: '/copy/:sn',
                    meta: { login: true },
                    component: Copy
                },{
                    path: '/terminalAdd',
                    meta: { login: true },
                    component: TerminalAdd
                },{
                    path: '/modifyPassword',
                    meta: { login: true },
                    component: ModifyPassword
                },{
                    path: '/quit',
                    meta: { login: true },
                    component: Quit
                },{
                    path: '/alertHistory',
                    meta: { login: true },
                    component: AlertHistory
                },{
                    path: '/appDownload',
                    meta: { login: true },
                    component: AppDownload
                },{
                    path: '/groupDetail/:id/:name',
                    meta: { login: true },
                    component: GroupDetail
                },{
                    path: '/ReportDetail',
                    meta: { login: true },
                    component: reportDetail
                },{
                    path: '/ReportDownload',
                    meta: { login: true },
                    component: reportDownload
                },{
                    path: '/TerminalListReport',
                    meta: { login: true },
                    component: TerminalListReport
                },{
                    path: '/TerminalParameterReport',
                    meta: { login: true },
                    component: TerminalParameterReport
                },{
                    path: '/CreateTable',
                    meta: { login: true },
                    component: createTable
                },{
                    path: '/Functionlist',
                    meta: { login: true },
                    component: functionList
                },{
                    path: '/FunctionAdd',
                    meta: { login: true },
                    component: functionAdd
                },{
                    path: '/FunctionEdit',
                    meta: { login: true },
                    component: functionEdit
                },{
                    path: '/groupManage',
                    meta: { login: true },
                    component: GroupManage,
                    redirect: '/grouplist',
                    children: [{
                      path: '/grouplist',
                      meta: { login: true },
                      component: Grouplist
                    },{
                      path: '/groupAdd',
                      meta: { login: true },
                      component: GroupAdd
                    },{
                      path: '/groupTerminalParameter/:groupId/:groupName',
                      meta: { login: true },
                      component: GroupTerminalParameter
                    },{
                      path: '/groupEdit/:groupId/:groupName',
                      meta: { login: true },
                      component: GroupEdit
                    }]
                },{
                    path: '/merchantManage',
                    meta: { login: true },
                    component: MerchantManage,
                    redirect: '/merchantlist',
                    children: [{
                      path: '/merchantlist',
                      meta: { login: true },
                      component: Merchantlist
                    },{
                      path: '/merchantAdde',
                      meta: { login: true },
                      component: MerchantAdde
                    }]
                },{
                    path: '/systemAdmin',
                    meta: { login: true },
                    component: SystemAdmin,
                    redirect: '/adminList',
                    children: [{
                      path: '/adminList',
                      meta: { login: true },
                      component: AdminList
                    },{
                      path: '/adminAdd/:id',
                      meta: { login: true },
                      component: AdminAdd
                    }]
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.login) {
        let verifoneLoginFlag = sessionStorage.getItem('verifoneLoginFlag');
        let verifoneRoleId = GlobalVar.roleList;


        if(!verifoneLoginFlag) {
            console.log(verifoneLoginFlag);
            next('/login');
        }else {
            // 10: Merchant Management;   11: Merchant Query
            // 20: Group Management
            // 30: App Management;        31: App Query
            // 40: Terminal Management    41: Terminal Query
            // 50: Download Management;   51: Download Query
            // 60: Diagnostic Management
            // 70: Alert Management;      71: Alert Query
            // 80: User Management

            // if(to.path == '/home' || to.path == '/dashboard') {
                 next();
            // }else if(to.path == '/systemAdmin' && verifoneRoleId == 0) {
            //     next();
            // }else if(to.path == '/appManagementContain' || to.path == '/appManagement' || to.path.indexOf('/appEdit') != -1 || to.path == '/createDownload' || to.path == '/downloadList') {
            //     if(verifoneRoleId == 1 || verifoneRoleId == 2 ||  verifoneRoleId == 0) {
            //         next();
            //     }
            // }else if(to.path == '/terminalManagement' || to.path == '/terminalList' || to.path.indexOf('/terminalOperate') != -1) {
            //     if(verifoneRoleId == 1 || verifoneRoleId == 3 || verifoneRoleId == 0) {
            //         next();
            //     }
            // }

        }
    }else {
        next();
    }

});

let countHeader = 0;
//axiosIns.defaults.baseURL = 'http://10.172.96.80:8080/';

// axiosIns.defaults.headers = {
//     'Accept-Language': GlobalVar.acceptLanguage
// }

axiosIns.interceptors.request.use(function (config) {
    let interfaceStr = config.url.split('marketplace')[1];

    if (interfaceStr == '/alert/count' || interfaceStr == '/app/apk') {

    } else {
        loadingInstance = Loading.service({
            lock: true,
            text: 'Loading...',
            background: 'rgba(255, 255, 255, 0.5)'
        });
    }

    return config;
});

axiosIns.interceptors.response.use(function (response) {
    if (loadingInstance!=null){
        loadingInstance.close();
    }

    let data = response.data;
    let status = response.status;

    if(response.data.resultCode == 2) {
        console.log('resultCode == 2');
        //this.$router.replace('/login');
        router.replace('/login');
    }

    if (status === 200) {
        if(response.data.errorCode == '216'){
            localStorage.clear();
            location.reload();
        }
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }

}, function (error) {
    loadingInstance.close();

    // if error
    ElementUI.Message({
        type: "error",
        message: 'Please try again later！',
        duration: "2000",
    });

    return Promise.reject(error);
});


Vue.prototype.$axios = axiosIns;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js